import { api } from "../api";
import axios from "axios";


export const getTodayTasks = async (userId) => {
    const res = await axios.get(api + 'todo-today/' + userId,
        {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token'),
                Accept: "application/json",
            }
        });
    return res.data;
}

export const updateTodoTask = async (reproductionId, statusName) => {
    const res = await axios.patch(api + 'todo-today/update/' + reproductionId + '/' + statusName, {}, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            Accept: "application/json",
        }
    });
    return res.data;
};
export const updateSupprimeEventA = async (reproductionId, statusName) => {
    const res = await axios.patch(api + 'todo-todayA/supprimer-event/' + reproductionId + '/' + statusName, {}, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            Accept: "application/json",
        }
    });
    return res.data;
};
export const updateSupprimeEvent = async (reproductionId, statusName) => {
    const res = await axios.patch(api + 'todo-today/supprimer-event/' + reproductionId + '/' + statusName, {}, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            Accept: "application/json",
        }
    });
    return res.data;
};
export const updateTodoTaskA = async (reproductionId, statusName) => {
    const res = await axios.patch(api + 'todo-todayA/update/' + reproductionId + '/' + statusName, {}, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            Accept: "application/json",
        }
    });
    return res.data;
};

export const markDone = async (id) => {
    const res = await axios.patch(api + 'todo-today/done/' + id,{},
        {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token'),
                Accept: "application/json",
            }
        }
    );
    return res.data;
};
export const markUnDone = async (id) => {
    const res = await axios.patch(api + 'todo-today/undone/' + id,{},
        {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token'),
                Accept: "application/json",
            }
        }
    );
    return res.data;
};

export const getTodayTasksA = async () => {
    const res = await axios.get(api + 'todo-todayA/' ,
        {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token'),
                Accept: "application/json",
            }
        });
    return res.data;
}

export const markDoneA = async (id) => {
    const res = await axios.patch(api + 'todo-today/doneA/' + id,{},
        {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token'),
                Accept: "application/json",
            }
        }
    );
    return res.data;
};
export const markUnDoneA = async (id) => {
    const res = await axios.patch(api + 'todo-today/undoneA/' + id,{},
        {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token'),
                Accept: "application/json",
            }
        }
    );
    return res.data;
};